'use client'

import { usePostHog } from '@posthog/next'
import { useParams } from 'next/navigation'
import { useEffect } from 'react'

import { getDisablePosthogRecordingRoomIds } from '@/lib/configs'

export default function PostHogRecordingGate() {
  const posthog = usePostHog()
  const params = useParams<{ roomId?: string }>()
  const roomId = params?.roomId

  useEffect(() => {
    const shouldDisable = !!roomId && getDisablePosthogRecordingRoomIds().includes(roomId)

    if (shouldDisable) {
      posthog.stopSessionRecording()
    } else {
      posthog.startSessionRecording()
    }
  }, [posthog, roomId])

  return null
}
